
const lax = {
    lat: 33.7701,
    lng: -118.1937
}

const mia = {
    lat: 25.8195012,
    lng: -80.2657908
}

const chicago = {
    lat: 41.9552802,
    lng: -87.7941514
}

const dallas = {
    lat: 32.8054368,
    lng: -96.8455895
}

const bay = {
    lat: 37.5087117,
    lng: -121.9729078
}

const sandiego = {
    lat: 32.595583,
    lng: -117.0343536
}

const phx = {
    lat: 33.4488248,
    lng: -112.2411795
}

const jfk = {
    lat: 40.7139762,
    lng: -73.9195434
}

export function getMapCenterByCityIdUS(cityId = 1) {
    switch (cityId) {
        case 1:
            return lax
        case 2:
            return mia
        case 3:
            return chicago
        case 4:
            return dallas
        case 12:
            return bay
        case 13:
            return sandiego
        case 16:
            return phx
        case 17:
            return jfk
        default:
            return lax
    }
}